const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  batchValidateTradevans ({ state, commit, rootState }, params) {
    return rootState.axios.post('/auth/v1frontend/realauth/batch-validate-tradevans', params)
  },
  // NATSW Portal 批量创建
  batchCreateNatswPortal ({ state, commit, rootState }, params) {
    return rootState.axios.post('/auth/v1frontend/realauth/batch-create-natsw-portal', params)
  },
  // NATSW Portal 批量验证轮询
  batchVerifyNatswPortal ({ state, commit, rootState }, params) {
    return rootState.axios.get('/auth/v1frontend/realauth/batch-verify-natsw-portal', {
      params
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/realauth.js